import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { FACILITADORAS } from '../../data/retiro';
export function Facilitadoras() {
  return <section id="facilitadoras" className="w-full px-5 py-24 sm:px-8 sm:py-32" data-id="element-66">
      <div className="mx-auto max-w-6xl" data-id="element-67">
        <SectionHeading eyebrow="Tus Facilitadoras" title="Guías que sostienen tu proceso con amor y maestría" data-id="element-68" />

        <div className="mt-16 flex flex-col gap-8" data-id="element-69">
          {FACILITADORAS.map((f, i) => <Reveal key={f.nombre} delay={i * 0.05} data-id="element-70">
              <article className="rounded-[2rem] border p-8 sm:p-10" style={{
            borderColor: 'rgba(42,36,32,0.1)',
            backgroundColor: 'white'
          }} data-id="element-71">
                <div className="grid gap-8 md:grid-cols-[auto,1fr]" data-id="element-72">
                  <div className="flex items-center gap-5 md:w-56 md:flex-col md:items-start md:gap-4" data-id="element-73">
                    <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full text-3xl" style={{
                  backgroundColor: f.acento
                }} data-id="element-74">
                      {f.emoji}
                    </div>
                    <div data-id="element-75">
                      <h3 className="font-heading text-2xl font-light" style={{
                    color: 'var(--ink)'
                  }} data-id="element-76">
                        {f.nombre}
                      </h3>
                      <p className="text-sm" style={{
                    color: f.acento
                  }} data-id="element-77">
                        {f.rol}
                      </p>
                    </div>
                  </div>

                  <div data-id="element-78">
                    <blockquote className="border-l-2 pl-5 font-heading text-base font-light italic leading-relaxed" style={{
                  borderColor: f.acento,
                  color: 'var(--ink)'
                }} data-id="element-79">
                      "{f.cita}"
                    </blockquote>

                    <div className="mt-5 space-y-3" data-id="element-80">
                      {f.parrafos.map((p, idx) => <p key={idx} className="text-sm leading-relaxed" style={{
                    color: 'rgba(42,36,32,0.72)'
                  }} data-id="element-81">
                          {p}
                        </p>)}
                    </div>

                    {f.lista && <div className="mt-6" data-id="element-82">
                        <p className="mb-3 text-xs font-medium uppercase tracking-[0.2em]" style={{
                    color: f.acento
                  }} data-id="element-83">
                          {f.lista.titulo}
                        </p>
                        <ul className="grid gap-2 sm:grid-cols-2" data-id="element-84">
                          {f.lista.items.map(item => <li key={item} className="flex items-start gap-2 text-sm" style={{
                      color: 'rgba(42,36,32,0.78)'
                    }} data-id="element-85">
                              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                        color: f.acento
                      }} data-id="element-86" />
                              <span data-id="element-87">{item}</span>
                            </li>)}
                        </ul>
                      </div>}
                  </div>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}